<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="section-wrapper contract-data-wrapper" formGroupName="contract">

            <div class="section-headline optional">

                <mat-icon class="main-icon">assignment</mat-icon>
    
                <span class="text">
                    Kopfdaten
                </span>
    
                <span class="spacer"></span>
    
            </div>

            <div class="section-content">

                <app-contract-form style="flex: 1; width: 100%;" [editMode]="!disabled" [showIdGenerator]="false"></app-contract-form>

                <app-concurrency-label [entityIsSupported]="false"></app-concurrency-label>
    
            </div>
        </div>

        <div class="section-wrapper" formArrayName="contractItems">

            <div class="section-headline optional">

                <mat-icon class="main-icon">router</mat-icon>
    
                <span class="text">
                    Vertragsartikel
                </span>
    
                <span class="spacer"></span>

                <div *ngIf="!disabled" class="control-button" (click)="addArticle()" matTooltip="Neuen Artikel anlegen">
                    <mat-icon>add</mat-icon>
                </div>

                <div *ngIf="!disabled" class="control-button" (click)="openItemAssist()" matTooltip="AMS Artikelassistent">
                    <mat-icon>adb</mat-icon>
                </div>
    
            </div>

            <app-contract-items-form *ngIf="!itemsRefreshing" @show [disabled]="disabled"></app-contract-items-form>

        </div>

    </div>

</div>
